import React from 'react';
import CandidateManagementView from './CandidateManagementView';

const CandidateManagementContainer = (props) => {
  return <CandidateManagementView {...props} />;
};

export default CandidateManagementContainer;
